export const zuiGray = {
  25: '#F9F9FA',
  50: '#F4F4F6',
  100: '#E6E6EA',
  200: '#CBCBD2',
  300: '#AFAFBB',
  400: '#9494A4',
  500: '#78788C',
  600: '#606071',
  700: '#494955',
  800: '#31313A',
  900: '#1A1A1E',
};
